import React, { useEffect, useState } from "react";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import Box from "@mui/material/Box";
import { Grid, Button } from "@mui/material/";
import Backdrop from "@mui/material/Backdrop";

import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  db,
  collection,
  doc,
  query,
  orderBy,
  getDocs,
  addDoc,
  updateDoc,
} from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router-dom";

import CurrencyFormat from "react-currency-format";

import "moment-timezone";
import AdminCheck from "./AdminCheck";
import emailjs from "@emailjs/browser";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const AdminDashboard = () => {
  const { t, i18n } = useTranslation();

  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;

  currentLocation = "KO";

  let { newPage } = useParams();
  // console.log(newPage);

  let navigate = useNavigate();

  const [page, setPage] = useState(newPage);
  const [pageSize, setPageSize] = useState(10);

  const [ordersFull, setOrdersFull] = useState([]);
  const [usersFull, setUsersFull] = useState([]);
  const [orders, setOrders] = useState([]);

  const [search, setSearch] = useState(null);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [rows, setRows] = useState([]);

  const [selectionModel, setSelectionModel] = React.useState([]);
  const [updateAction, setUpdateAction] = useState("");

  const [msg, setMsg] = useState(null);

  const columns = [
    {
      field: "created",
      headerName: "구입 시간",
      minWidth: "170",

      renderCell: (params) => {
        // const curr = new Date(
        //   params.row.created.toDate().getFullYear(),
        //   params.row.created.toDate().getMonth(),
        //   params.row.created.toDate().getDate(),
        //   params.row.created.toDate().getHours(),
        //   params.row.created.toDate().getMinutes()
        // );

        // const utc = curr.getTime() + curr.getTimezoneOffset() * 60 * 1000;

        return (
          <strong>
            {params.row.created?.toDate().toLocaleDateString("fr-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}{" "}
            {params.row.created?.toDate().toLocaleTimeString("ko-KR", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </strong>
        );
      },
    },
    {
      field: "id",
      headerName: "주문 번호",
      minWidth: 160,
      renderCell: (params) => (
        <strong>
          <Button
            color="primary"
            target="_blank"
            sx={{ fontSize: "12px" }}
            href={
              params.row.guestPassword
                ? "/admin/order_guest_ko/" + params.row.id
                : "/admin/order_ko/" + params.row.id
            }
            style={{ color: "blue", textDecoration: "underline" }}
          >
            {params.row.id}
          </Button>
        </strong>
      ),
    },
    {
      field: "guestPassword",
      headerName: "회원/비회원",
      minWidth: 100,
      renderCell: (params) => {
        if (params.row.guestPassword && params.row.guestPassword.length > 0) {
          return <Box sx={{ color: "black" }}>비회원 주문</Box>;
        } else {
          return <Box sx={{ color: "black" }}>회원 주문</Box>;
        }
      },
    },
    {
      field: "status",
      headerName: "상태",
      width: 260,
      renderCell: (params) => (
        <strong>
          <Button
            color="secondary"
            target="_blank"
            href={"/admin/order_ko/" + params.row.id}
            style={{
              color: "#153a5a",
            }}
          >
            <Box sx={{ mr: "2px", fontWeight: 600, fontSize: "12px" }}>
              {t(params.row.status[params.row.status.length - 1].trim())}
            </Box>

            <Box sx={{ fontSize: "12px" }}>
              {params.row.payment_status.paymentOption ===
                "Deposit without bankbook" &&
              params.row.status[params.row.status.length - 1] ===
                "Preparing for shipment" ? (
                <>
                  <span style={{ color: "blue" }}>
                    &bull; 무통장 입금{" "}
                    <span style={{ color: "black" }}>(입금 확인요망)</span>
                  </span>
                </>
              ) : (
                ""
              )}
            </Box>
          </Button>
        </strong>
      ),
    },
    // { field: "shippingOption", headerName: "Shipping Option", width: 130 },
    {
      field: "finalPrice",
      headerName: "최종 가격",
      minWidth: 100,
      renderCell: (params) => (
        <CurrencyFormat
          value={params.row.finalPrice}
          displayType={"text"}
          thousandSeparator={true}
          suffix={"원"}
        />
      ),
    },
    {
      field: "shippingPrice",
      headerName: "배송 가격",
      minWidth: 80,
      renderCell: (params) => (
        <CurrencyFormat
          value={params.row.shippingPrice}
          displayType={"text"}
          thousandSeparator={true}
          suffix={"원"}
        />
      ),
    },

    {
      field: "address_lastname",
      headerName: "수취인 성",
      minWidth: "70",
    },
    {
      field: "address_firstname",
      headerName: "수취인 이름",
      minWidth: "70",
    },
    {
      field: "address_address",
      headerName: "수취인 주소",
      minWidth: "230",
    },
    {
      field: "address_city",
      headerName: "도시",
      minWidth: "100",
    },
    {
      field: "taxRate",
      headerName: "세금",
      minWidth: "100",
      valueGetter: (params) => `${params.row.taxRate}원`,
    },
    {
      field: "email",
      headerName: "이메일 주소",
      minWidth: "200",
    },
  ];

  useEffect(() => {
    setUsersFull([]);
    const getUsers = async () => {
      const q = query(collection(db, "users"), orderBy("created", "desc"));

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        // console.log(doc.id, " => ", doc.data());

        setUsersFull((old) =>
          old.concat({
            ...doc.data(),
            id: doc.id,
          })
        );
      });
    };
    // getUsers();

    setRows([]);
    getOrders();
  }, []);

  const [numOfStatus1, setNumOfStatus1] = useState(0);
  const [numOfStatus2, setNumOfStatus2] = useState(0);
  const [numOfStatus3, setNumOfStatus3] = useState(0);
  const [numOfStatus4, setNumOfStatus4] = useState(0);
  const [numOfStatus5, setNumOfStatus5] = useState(0);

  const getOrders = async () => {
    setOrders([]);
    const q2 = query(
      collection(db, currentLocation + "_" + "orders"),
      orderBy("created", "desc")
    );

    setNumOfStatus1(0);
    setNumOfStatus2(0);
    setNumOfStatus3(0);
    setNumOfStatus4(0);
    setNumOfStatus5(0);

    const querySnapshot = await getDocs(q2);
    querySnapshot.forEach((doc2) => {
      setRows((old) =>
        old.concat({
          ...doc2.data(),
          id: doc2.id,
        })
      );

      console.log(
        "doc2.data().status",
        doc2.data().status[doc2.data().status.length - 1]
      );
      if (
        doc2.data().status[doc2.data().status.length - 1] ===
        "Preparing for shipment"
      ) {
        setNumOfStatus1((old) => old + 1);
      } else if (
        doc2.data().status[doc2.data().status.length - 1] === "Order confirmed"
      ) {
        setNumOfStatus2((old) => old + 1);
      } else if (
        doc2.data().status[doc2.data().status.length - 1] === "Order delayed"
      ) {
        setNumOfStatus3((old) => old + 1);
      } else if (
        doc2.data().status[doc2.data().status.length - 1] === "Order cancelled"
      ) {
        setNumOfStatus4((old) => old + 1);
      } else {
        // order shipped
        setNumOfStatus5((old) => old + 1);
      }

      setOrdersFull((old) =>
        old.concat({
          ...doc2.data(),
          id: doc2.id,
        })
      );
      setOrders((old) =>
        old.concat({
          ...doc2.data(),
          id: doc2.id,
        })
      );
    });
  };

  console.log("selectionModel", selectionModel);

  // 발주 확인
  const orderConfirm = () => {
    if (selectionModel.length > 0) {
      setUpdateAction("Order confirm");
      handleOpen();
    } else {
      setMsg(t("Select at least one order to perform."));
      handleOpen();
      setTimeout(() => {
        setMsg(null);
        handleClose();
      }, 3000);
    }
  };

  const orderDelayed = () => {
    if (selectionModel.length > 0 || startDate !== new Date()) {
      setUpdateAction("Order delayed");
      handleOpen();
    } else {
      setMsg(t("Select at least one order to perform."));
      handleOpen();
      setTimeout(() => {
        setMsg(null);
        handleClose();
      }, 3000);
    }
  };

  const orderCancelled = () => {
    if (selectionModel.length > 0) {
      setUpdateAction("Order cancelled");
      handleOpen();
    } else {
      setMsg(t("Select at least one order to perform."));
      handleOpen();
      setTimeout(() => {
        setMsg(null);
        handleClose();
      }, 3000);
    }
  };

  const action = () => {
    if (updateAction === "Order confirm") {
      orderConfirmAction();
      setMsg(
        "<span style='color:#283593;'>발주 확인하고 이메일을 전송했습니다.</span><br /><br /> 예전에 발주 확인 되서 이메일이 보내진 주문들은 이메일 전송을 하지 않습니다."
      );
    } else if (updateAction === "Order delayed") {
      orderDelayedAction();
      setMsg(
        "<span style='color:#283593;'>발송 지연처리하고 이메일을 전송했습니다.</span><br /><br />"
      );
    } else if (updateAction === "Order cancelled") {
      orderCancelledAction();

      setMsg(
        "<span style='color:#283593;'>주문을 취소하고 이메일을 전송했습니다.</span><br /><br />"
      );
    }
    setTimeout(() => {
      setMsg(null);
      handleClose();
      if (page) {
        navigate(`/admin/orders_ko/${page}`);
      } else {
        navigate(`/admin/orders_ko/`);
      }
    }, 2000);
  };

  const orderCancelledAction = () => {
    orders.map(async (order) => {
      console.log("selectionModel", selectionModel);
      if (selectionModel.includes(order.id)) {
        console.log("Found ====>  ", order);
        // "order cancelled", "order shipped" 가 없을때
        if (
          !order.status.includes("Order cancelled") &&
          !order.status.includes("Order shipped")
        ) {
          try {
            console.log("order", order);

            console.log("order.id ======", order.id);
            const ref = doc(db, currentLocation + "_" + "orders", order.id);
            console.log("db name", currentLocation + "_" + "orders");
            console.log("order.status ====>  ", order.status);
            const newarr = [...order.status, "Order cancelled"];
            console.log("newarr ====>  ", newarr);

            await updateDoc(
              ref,
              {
                status: newarr,
              },
              { merge: true }
            );

            // Send it to the customer
            var templateParams1 = {
              user_email: order.email,
              from_name: order.address_lastname + " " + order.address_firstname,
              lastname: order.address_lastname,
              status: " 취소되었습니다",
            };
            emailjs
              .send(
                "service_66owpwy",
                "template_ub6tfci",
                templateParams1,
                "user_7Zql27tiMF2NZkNx1LGdg"
              )
              .then(
                (result) => {
                  console.log(result.text);
                },
                (error) => {
                  console.log(error.text);
                }
              );

            setStartDate(new Date());
            setReason(null);
            setDelayReason(null);
          } catch (err) {
            console.log(err);
            setMsg("Fail to send a message. The email address might be wrong.");
            setTimeout(() => {
              setMsg(null);
              handleClose();
            }, 2000);
          }
        }
      }
    });
  };

  const [startDate, setStartDate] = useState(new Date());
  const [reason, setReason] = useState(null);
  const [delayReason, setDelayReason] = useState(null);

  const orderDelayedAction = () => {
    let textToAdd = "";
    if (delayReason) {
      textToAdd = textToAdd + "<div>※ " + delayReason + "</div>";
    }
    if (reason) {
      textToAdd = textToAdd + "<div>※ 주문 지연 이유: " + reason + "</div>";
    }
    if (startDate !== new Date() && startDate > new Date()) {
      textToAdd =
        textToAdd +
        "<div>※ 배송 예상도착 날짜: " +
        startDate.toLocaleDateString("fr-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }) +
        "</div>";
    }

    orders.map(async (order) => {
      if (selectionModel.includes(order.id)) {
        console.log("Found ====>  ", order);
        // "order delayed", "order shipped", "Order cancelled" 가 없을때
        if (
          !order.status.includes("Order delayed") &&
          !order.status.includes("Order shipped") &&
          !order.status.includes("Order cancelled")
        ) {
          try {
            const ref = doc(db, currentLocation + "_" + "orders", order.id);
            const newarr = [...order.status, "Order delayed"];

            await updateDoc(
              ref,
              {
                status: newarr,
              },
              { merge: true }
            );

            // Send it to the customer
            var templateParams1 = {
              user_email: order.email,
              from_name: order.address_lastname + " " + order.address_firstname,
              lastname: order.address_lastname,
              status: " 지연되었습니다",
            };
            emailjs
              .send(
                "service_66owpwy",
                "template_ub6tfci",
                templateParams1,
                "user_7Zql27tiMF2NZkNx1LGdg"
              )
              .then(
                (result) => {
                  console.log(result.text);
                },
                (error) => {
                  console.log(error.text);
                }
              );
            setStartDate(new Date());
            setReason(null);
            setDelayReason(null);
          } catch (err) {
            console.log(err);
            setMsg("Fail to send a message. The email address might be wrong.");
            setTimeout(() => {
              setMsg(null);
              handleClose();
            }, 2000);
          }
        }
      }
    });
  };

  const orderConfirmAction = () => {
    orders.map(async (order) => {
      if (selectionModel.includes(order.id)) {
        console.log("Found ====>  ", order);

        // "order confirmed" 가 없을때
        if (
          !order.status.includes("Order confirmed") &&
          !order.status.includes("Order shipped") &&
          !order.status.includes("Order delayed") &&
          !order.status.includes("Order cancelled")
        ) {
          try {
            console.log("order.id ======", order.id);
            const ref = doc(db, currentLocation + "_" + "orders", order.id);
            console.log("order.status ====>  ", order.status);
            const newarr = [...order.status, "Order confirmed"];
            console.log("newarr ====>  ", newarr);

            await updateDoc(
              ref,
              {
                status: newarr,
              },
              { merge: true }
            );
            // Send it to the customer
            var templateParams1 = {
              user_email: order.email,
              from_name: order.address_lastname + " " + order.address_firstname,
              lastname: order.address_lastname,
              status: " 발주확인 되었습니다",
            };
            emailjs
              .send(
                "service_66owpwy",
                "template_ub6tfci",
                templateParams1,
                "user_7Zql27tiMF2NZkNx1LGdg"
              )
              .then(
                (result) => {
                  console.log(result.text);
                },
                (error) => {
                  console.log(error.text);
                }
              );
          } catch (error) {
            setMsg("Fail to send a message. The email address might be wrong.");
            setTimeout(() => {
              setMsg(null);
              handleClose();
            }, 2000);
          }
        }
      }
    });
  };

  console.log("page", page);

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                {msg ? (
                  <Box>
                    <Typography
                      id="transition-modal-title"
                      sx={{ fontSize: "14px", fontWeight: 600 }}
                    >
                      {t(updateAction)} ({selectionModel.length} {t("item")})
                      <Box sx={{ mt: 3 }}>
                        <div dangerouslySetInnerHTML={{ __html: msg }} />
                      </Box>
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <Typography
                      id="transition-modal-title"
                      sx={{ fontSize: "14px", fontWeight: 600 }}
                    >
                      {t(updateAction)} ({selectionModel.length} {t("item")})
                    </Typography>
                    <Box sx={{ mt: 2, lineHeight: "2.2em" }}>
                      {selectionModel.map((select) => {
                        return (
                          <Box>
                            {t("Order")} #: {select}{" "}
                          </Box>
                        );
                      })}
                    </Box>

                    {updateAction === "Order delayed" ? (
                      <div style={{ fontSize: "13px" }}>
                        <Box sx={{ color: "#283593", pb: 2 }}>
                          발송 지연처리는 '1회'만 가능합니다. 이메일을 보내실때
                          발송 기한을 고객에게 보낼수있습니다.
                        </Box>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              {t("Reason of the delay")}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={reason}
                              label="Age"
                              onChange={(e) => setReason(e.target.value)}
                            >
                              <MenuItem value={t("Preparing for the product")}>
                                {t("Preparing for the product")}
                              </MenuItem>
                              <MenuItem value={t("Customer request")}>
                                {t("Customer request")}
                              </MenuItem>
                              <MenuItem value={t("Custom order")}>
                                {t("Custom order")}
                              </MenuItem>
                              <MenuItem value={t("Scheduled shipment")}>
                                {t("Scheduled shipment")}
                              </MenuItem>
                              <MenuItem value={t("Oversea shipment")}>
                                {t("Oversea shipment")}
                              </MenuItem>
                              <MenuItem value={t("Other")}>
                                {t("Other")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                          <Box
                            sx={{
                              display: "flex",
                              width: 1,
                              alignItems: "center",
                              pt: 2,
                            }}
                          >
                            <Box sx={{ width: 1 / 2, paddingTop: "9px" }}>
                              발송 기한
                            </Box>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                            />
                          </Box>
                          <Box
                            sx={{
                              width: 1,
                              pt: 2,
                            }}
                          >
                            <Box sx={{ width: 1, paddingTop: "9px", mb: 2 }}>
                              발송 지연 상세 사유 (선택 사항입니다)
                            </Box>
                            <TextField
                              value={delayReason}
                              onChange={(e) => setDelayReason(e.target.value)}
                              multiline
                              rows={10}
                              sx={{ width: 1 }}
                            />
                          </Box>
                        </Box>
                      </div>
                    ) : null}

                    <button
                      className="custom_btn"
                      style={{ marginTop: "20px" }}
                      onClick={action}
                    >
                      {t(updateAction)} {t("Confirm")}
                    </button>
                  </>
                )}
                <button
                  className="custom_btn_whitebg"
                  style={{ marginTop: "10px" }}
                  onClick={handleClose}
                >
                  {t("Close")}
                </button>
              </Box>
            </Fade>
          </Modal>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%" }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px", fontWeight: 600 }}>
                  모든 주문들 ({ordersFull?.length})
                </Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>

              <Box sx={{ mt: 3, display: "flex" }}>
                <button
                  className="custom_btn_whitebg"
                  style={{
                    width: "140px",
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                  }}
                  onClick={orderConfirm}
                >
                  발주 확인
                </button>
                <button
                  className="custom_btn_whitebg"
                  style={{
                    width: "140px",
                    marginLeft: "5px",
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                  }}
                  onClick={orderDelayed}
                >
                  발송 지연 처리
                </button>
                <button
                  className="custom_btn_whitebg"
                  style={{
                    width: "140px",
                    marginLeft: "5px",
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                  }}
                  onClick={orderCancelled}
                >
                  주문 취소
                </button>
              </Box>

              <Grid container>
                <Grid
                  className="normal"
                  item
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ pb: 10, pt: 4 }}
                >
                  <Box sx={{ mb: 1, fontSize: "13px" }}>
                    주문 발송은 각 주문의 주문 번호를 클릭해서 업데이트
                    해주세요.
                  </Box>
                  <Box sx={{ pb: 1, fontSize: "13px" }}>
                    <span style={{ fontWeight: "bold" }}>발주확인</span> &rarr;
                    (<span style={{ fontWeight: "bold" }}>발송지연</span>처리)
                    &rarr;{" "}
                    <span style={{ fontWeight: "bold" }}>
                      주문취소, 주문완료
                    </span>{" "}
                    순서대로 진행 해주시길 바랍니다. 그 전단계로는 갈수
                    없습니다.
                  </Box>
                  <Box sx={{ pb: 2 }}>
                    무통장 입금의 경우, 입금을 확인하셨으면 '발주확인'을
                    눌러주세요
                  </Box>
                  <Box
                    sx={{
                      mb: 2,
                      border: "1px solid lightgray",
                      borderRadius: "5px",
                      backgroundColor: "white",
                      p: 2,
                      fontSize: "12px",
                      display: "flex",
                      justifyContent: "space-around",
                    }}
                  >
                    <Box>※ 주문 확인중: {numOfStatus1}</Box>
                    <Box>※ 발주 확인: {numOfStatus2}</Box>
                    <Box>※ 발송 지연: {numOfStatus3}</Box>
                    <Box>※ 주문 취소: {numOfStatus4}</Box>
                    <Box>※ 발송 완료: {numOfStatus5}</Box>
                  </Box>
                  <div
                    style={{
                      minHeight: 250,
                      width: "100%",
                      backgroundColor: "white",
                    }}
                  >
                    {newPage && (
                      <DataGrid
                        rowHeight={40}
                        checkboxSelection
                        onSelectionModelChange={(newSelectionModel) => {
                          setSelectionModel(newSelectionModel);
                        }}
                        selectionModel={selectionModel}
                        components={{ Toolbar: GridToolbar }}
                        rows={rows}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        rowsPerPageOptions={[5, 10, 20]}
                        page={newPage}
                        onPageChange={(newPage) => setPage(newPage)}
                        sx={{
                          display: "none",

                          "& .MuiDataGrid-cell": {
                            fontSize: "12px",
                          },
                          "&.MuiDataGrid-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                    {rows && (
                      <DataGrid
                        rowHeight={40}
                        checkboxSelection
                        onSelectionModelChange={(newSelectionModel) => {
                          setSelectionModel(newSelectionModel);
                        }}
                        selectionModel={selectionModel}
                        components={{ Toolbar: GridToolbar }}
                        rows={rows}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        rowsPerPageOptions={[
                          10, 20, 30, 40, 50, 60, 70, 80, 100,
                        ]}
                        page={page}
                        onPageChange={(newPage) => setPage(newPage)}
                        sx={{
                          height: "580px",
                          fontSize: "13px",
                          "& .MuiDataGrid-cell": {
                            fontSize: "12px",
                          },
                          "&.MuiDataGrid-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  </div>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
